export const applicantConstants = {
  GETALL_REQUEST: "APPLICANT_GETALL_REQUEST",
  GETALL_SUCCESS: "APPLICANT_GETALL_SUCCESS",
  GETALL_FAILURE: "APPLICANT_GETALL_FAILURE",

  GETALL_SUCCESS_LOADER: "GETALL_SUCCESS_LOADER",

  CREATE_REQUEST: "APPLICANT_CREATE_REQUEST",
  CREATE_SUCCESS: "APPLICANT_CREATE_SUCCESS",
  CREATE_FAILURE: "APPLICANT_CREATE_FAILURE",

  CANDIDATE_REFERRAL_REQUEST: "CANDIDATE_REFERRAL_CREATE_REQUEST",
  CANDIDATE_REFERRAL_SUCCESS: "CANDIDATE_REFERRAL_CREATE_SUCCESS",
  CANDIDATE_REFERRAL_FAILURE: "CANDIDATE_REFERRAL_CREATE_FAILURE",

  CREATEEXTERNAL_REQUEST: "EXTERNAL_APPLICANT_CREATE_REQUEST",
  CREATEEXTERNAL_SUCCESS: "EXTERNAL_APPLICANT_CREATE_SUCCESS",
  CREATEEXTERNAL_FAILURE: "EXTERNAL_APPLICANT_CREATE_FAILURE",

  UPDATE_REQUEST: "APPLICANT_UPDATE_REQUEST",
  UPDATE_SUCCESS: "APPLICANT_UPDATE_SUCCESS",
  UPDATE_FAILURE: "APPLICANT_UPDATE_FAILURE",

  GET_REQUEST: "APPLICANT_GET_REQUEST",
  GET_SUCCESS: "APPLICANT_GET_SUCCESS",
  GET_FAILURE: "APPLICANT_GET_FAILURE",

  DELETE_REQUEST: "APPLICANT_DELETE_REQUEST",
  DELETE_SUCCESS: "APPLICANT_DELETE_SUCCESS",
  DELETE_FAILURE: "APPLICANT_DELETE_FAILURE",

  GETHISTORY_REQUEST: "APPLICANT_GETHISTORY_REQUEST",
  GETHISTORY_SUCCESS: "APPLICANT_GETHISTORY_SUCCESS",
  GETHISTORY_FAILURE: "APPLICANT_GETHISTORY_FAILURE",

  GETCOMMENT_REQUEST: "APPLICANT_GETCOMMENT_REQUEST",
  GETCOMMENT_SUCCESS: "APPLICANT_GETCOMMENT_SUCCESS",
  GETCOMMENT_FAILURE: "APPLICANT_GETCOMMENT_FAILURE",
  REMOVECOMMENTS: "REMOVECOMMENTS",

  CREATECOMMENT_REQUEST: "APPLICANT_CREATECOMMENT_REQUEST",
  CREATECOMMENT_SUCCESS: "APPLICANT_CREATECOMMENT_SUCCESS",
  CREATECOMMENT_FAILURE: "APPLICANT_CREATECOMMENT_FAILURE",

  UPDATECOMMENT_REQUEST: "APPLICANT_UPDATECOMMENT_REQUEST",
  UPDATECOMMENT_SUCCESS: "APPLICANT_UPDATECOMMENT_SUCCESS",
  UPDATECOMMENT_FAILURE: "APPLICANT_UPDATECOMMENT_FAILURE",

  DELETECOMMENT_REQUEST: "APPLICANT_DELETECOMMENT_REQUEST",
  DELETECOMMENT_SUCCESS: "APPLICANT_DELETECOMMENT_SUCCESS",
  DELETECOMMENT_FAILURE: "APPLICANT_DELETECOMMENT_FAILURE",

  UPDATECOMMENTACCESS_REQUEST: "APPLICANT_UPDATECOMMENTACCESS_REQUEST",
  UPDATECOMMENTACCESS_SUCCESS: "APPLICANT_UPDATECOMMENTACCESS_SUCCESS",
  UPDATECOMMENTACCESS_FAILURE: "APPLICANT_UPDATECOMMENTACCESS_FAILURE",

  DYNAMIC_REFERRAL_REQUEST: "MOVE_DYNAMIC_REFERRAL_REQUEST",
  DYNAMIC_REFERRAL_SUCCESS: "MOVE_DYNAMIC_REFERRAL_SUCCESS",
  DYNAMIC_REFERRAL_FAILURE: "MOVE_DYNAMIC_REFERRAL_FAILURE",

  CLONE_JOB_REQUEST: "MOVE_CLONE_JOB_REQUEST",
  CLONE_JOB_SUCCESS: "MOVE_CLONE_JOB_SUCCESS",
  CLONE_JOB_FAILURE: "MOVE_CLONE_JOB_FAILURE",

  GETSUMMARY_REQUEST: "SUMMARY_GET_REQUEST",
  GETSUMMARY_SUCCESS: "SUMMARY_GET_SUCCESS",
  GETSUMMARY_FAILURE: "SUMMARY_GET_FAILURE",

  GETCHARTSUMMARY_REQUEST: "CHRT_SUMMARY_GET_REQUEST",
  GETCHARTSUMMARY_SUCCESS: "CHART_SUMMARY_GET_SUCCESS",
  GETCHARTSUMMARY_FAILURE: "CHART_SUMMARY_GET_FAILURE",

  GETEXTERNALDATA_REQUEST: "EXTERNAL_DATA_GET_REQUEST",
  GETEXTERNALDATA_SUCCESS: "EXTERNAL_DATA_GET_SUCCESS",
  GETEXTERNALDATA_FAILURE: "EXTERNAL_DATA_GET_FAILURE",

  GETBOARDDATA_REQUEST: "BOARD_DATA_GET_REQUEST",
  GETBOARDDATA_SUCCESS: "BOARD_DATA_GET_SUCCESS",
  GETBOARDDATA_FAILURE: "BOARD_DATA_GET_FAILURE",

  UPDATESTATUS_REQUEST: "UPDATE_STATUS_REQUEST",
  UPDATESTATUS_SUCCESS: "UPDATE_STATUS_SUCCESS",
  UPDATESTATUS_FAILURE: "UPDATE_STATUS_FAILURE",

  GETSTATUSDATA_REQUEST: "GET_STATUS_REQUEST",
  GETSTATUSDATA_SUCCESS: "GET_STATUS_SUCCESS",
  GETSTATUSDATA_FAILURE: "GET_STATUS_FAILURE",
};
